import {isIEBrowser} from '@/utils'

var SecCtrl;

var CertInfo=function () {
  //当前交易平台
  this.traddingOrgId='';
  //证书名称（友好名称）
  this.certName;
  //证书序列号
  this.certserial;
  //证书有效开始时间
  this.validstarttime;
  //证书有效截至时间
  this.validendtime;
  //证书拥有者名称
  this.subject_cn;
  //base64编码签名证书
  this.base64cert;
  //证书签名数据
  this.certsigndata;
  this.random;
  //判断是否有插入CA
  this.caLegalCode;
  //证书拥有者DN
  this.friendlyName;
  //身份证信息
  this.caIdCard;
}

var Hnca = function () {
  this.caname = "HN";
  this.caIP = "";
  this.serverUrl = "";
  this.caPort = "";
  this.random = "";
  this.certInfo = new CertInfo();
  this.certList = [];
  this.provider = 'GGZY';
  this.caOCX = undefined;
  this.hasInit = false;
};

function danweiName(arr) {
  let array = arr.split(',')
  let arr1 = array[3].split('=')
  let name = arr1[1]
  return name
}

Hnca.prototype = {
  /**
   * 获取控件对象
   */
  getHnObjcet: function (objname) {
    return document.getElementById(objname);
  },
  /**
   * 初始化Ocx插件
   */
  initOcxPlugin() {
    SecCtrl = this.getHnObjcet("SecCtrl");
    console.log(SecCtrl)
    if (SecCtrl === undefined || !isIEBrowser()) {
      alert("请确认河南CA的UKEY是否正确插入");
    }
    this.init(this.provider, '', '')
    if (!this.init(this.provider, '', '')) {
      alert("初始化失败请检查配置");
    }
  },
  /**
   * 初始化*/
  init(p_provider, p_alg, p_path) {
    let ks_provider, ks_alg, ks_path, lRet;
    if (p_provider != null && p_provider != "") {
      ks_provider = p_provider;
    }
    if (p_alg != null && p_alg != "") {
      ks_alg = p_alg;
    }
    if (p_path != null && p_path != "") {
      ks_path = p_path;
    }
    if (isIEBrowser()) {
      lRet = SecCtrl.KS_SetProv(ks_provider, ks_alg, ks_path);
      if (lRet != 0) {
        alert(SecCtrl.KS_GetLastErrorMsg());
      }
      return true;
    } else {
      return false;
    }
  },

  /**
   * 加载当前环境所有CA列表
   * @returns {boolean}
   */
  getCaKeyInfo: function (callback) {
    this.certInfo.random = SecCtrl.KS_GenRandom(16)
    this.certInfo.base64cert = SecCtrl.KS_GetCert(2);
    this.certInfo.certserial = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 2)
    this.certInfo.certName = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 1008)
    this.certInfo.subject_cn = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 1008)
    this.certInfo.validstarttime = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 11);//证书开始时间：
    this.certInfo.validendtime = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert, 12);//证书到期时间：
    this.certInfo.caLegalCode = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert,1002);
    this.certInfo.friendlyName = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert,21);
    this.certInfo.caIdCard = SecCtrl.KS_GetCertInfo(this.certInfo.base64cert,1001);
    // this.certInfo.certName = danweiName(this.certInfo.certName)
    callback && callback(this.certInfo)
  },
  /**
   * 验证密码并生成签名
   * @param inData
   * @param keyPin
   * @param successCallback
   * @returns {string|boolean|*}
   */
  getSignData: function () {
    return this.certInfo.certsigndata = SecCtrl.KS_SignData(this.certInfo.random, 0)
  },
};


export default Hnca
